import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import React from 'react';
import Timezones from 'timezones.json';

import classes from './TimeZonePicker.style';

export interface ComponentProps {
  value?: string;
  onChange: (newTimeZone: string) => void;
}

function TimeZonePicker({ value, onChange }: ComponentProps) {
  return (
    <TextField
      variant="standard"
      select
      fullWidth
      label="Time zone"
      name="timezone"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      margin="normal"
      sx={classes.text}
    >
      {Timezones.map((tz) => (
        <MenuItem key={tz.text} value={value && tz.utc.includes(value) ? value : tz.utc[0]} dense>{tz.text}</MenuItem>
      ))}
    </TextField>
  );
}

export default TimeZonePicker;
